var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._b({ref:"textarea",staticClass:"min-h-textarea w-full resize-none rounded border border-solid border-gray-300 bg-transparent p-2 focus:outline-none",domProps:{"value":_vm.value},on:{"input":_vm.change}},'textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }